import { render, staticRenderFns } from "./UserActivityReport.vue?vue&type=template&id=23652216&scoped=true"
import script from "./UserActivityReport.vue?vue&type=script&lang=js"
export * from "./UserActivityReport.vue?vue&type=script&lang=js"
import style0 from "./UserActivityReport.vue?vue&type=style&index=0&id=23652216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23652216",
  null
  
)

export default component.exports